// 本地环境配置
module.exports = {
  title: '检测',
  baseUrl: 'http://localhost:9020',
  // 项目地址
  baseApi: '/',
  // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  APPID: 'wx32f119d971b97acf'
};